// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/connector.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { EditorMarker } from "../../editor/v1/editor";
import { Struct } from "../../../../google/protobuf/struct";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { AppManagedStateBindingRef } from "./app_managed";
import { Any } from "../../../../google/protobuf/any";
import { File } from "../../filestore/v1/filestore";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.app.v1.GetConnectorSyncLifecycleRequest
 */
export interface GetConnectorSyncLifecycleRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * ConnectorCredential is used by a connector to authenticate with conductor one.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorCredential
 */
export interface ConnectorCredential {
    /**
     * The appId of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The connectorId of the connector the credential is associated with.
     *
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * The id of the ConnectorCredential.
     *
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the ConnectorCredential was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the ConnectorCredential was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the ConnectorCredential was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the ConnectorCredential was last used.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_used_at = 7;
     */
    lastUsedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the ConnectorCredential will expire.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_time = 8;
     */
    expiresTime?: Timestamp;
    /**
     * The display name of the ConnectorCredential.
     *
     * @generated from protobuf field: string display_name = 9;
     */
    displayName: string;
    /**
     * The client id of the ConnectorCredential.
     *
     * @generated from protobuf field: string client_id = 10;
     */
    clientId: string;
    /**
     * The client secret of the ConnectorCredential. It's only returned on creation.
     *
     * @generated from protobuf field: string client_secret = 11;
     */
    clientSecret: string;
}
/**
 * ConnectorServiceGetCredentialsRequest is a request for getting connector credentials. It uses URL values for input.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceGetCredentialsRequest
 */
export interface ConnectorServiceGetCredentialsRequest {
    /**
     * The appId of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The connectorId of the connector that we are getting the credentials for.
     *
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * The id of the ConnectorCredential.
     *
     * @generated from protobuf field: string id = 3;
     */
    id: string;
}
/**
 * ConnectorServiceGetCredentialsResponse is the response returned by the get method.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceGetCredentialsResponse
 */
export interface ConnectorServiceGetCredentialsResponse {
    /**
     * The connector credential returned by a get credentials request.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorCredential credential = 1;
     */
    credential?: ConnectorCredential;
}
/**
 * ConnectorServiceRotateCredentialResponse is the response returned by the rotate method.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceRotateCredentialResponse
 */
export interface ConnectorServiceRotateCredentialResponse {
    /**
     * The returned connector credential object.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorCredential credential = 1;
     */
    credential?: ConnectorCredential;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceListCredentialsRequest
 */
export interface ConnectorServiceListCredentialsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceListCredentialsResponse
 */
export interface ConnectorServiceListCredentialsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorCredential list = 1;
     */
    list: ConnectorCredential[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * ConnectorServiceRotateCredentialRequest is a request for rotating connector credentials. It uses URL values for input.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceRotateCredentialRequest
 */
export interface ConnectorServiceRotateCredentialRequest {
    /**
     * The appId of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The connectorId of the connector that we are rotating the credentials for.
     *
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * ConnectorServiceRevokeCredentialRequest is a request for revoking connector credentials. It uses URL values for input.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceRevokeCredentialRequest
 */
export interface ConnectorServiceRevokeCredentialRequest {
    /**
     * The appId of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The connectorId of the connector that we are revoking the credentials for.
     *
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * The id of the ConnectorCredential.
     *
     * @generated from protobuf field: string id = 3;
     */
    id: string;
}
/**
 * Empty response body. Status code indicates success.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceRevokeCredentialResponse
 */
export interface ConnectorServiceRevokeCredentialResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUploadRequest
 */
export interface ConnectorServiceUploadRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUploadResponse
 */
export interface ConnectorServiceUploadResponse {
    /**
     * @generated from protobuf field: string url = 1;
     */
    url: string;
}
/**
 * Signal the connector to start syncing. This puts the sync on the queue. It does not guarantee immediate sync. Long syncs still take minutes to hours.
 *
 * @generated from protobuf message c1.api.app.v1.ForceSyncRequest
 */
export interface ForceSyncRequest {
    /**
     * The AppID of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ConnectorID of the connector that we are forcing to sync.
     *
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ForceSyncResponse
 */
export interface ForceSyncResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ResumeSyncRequest
 */
export interface ResumeSyncRequest {
    /**
     * The AppID of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ConnectorID of the connector that we are resuming the sync for.
     *
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ResumeSyncResponse
 */
export interface ResumeSyncResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ConfirmSyncValidRequest
 */
export interface ConfirmSyncValidRequest {
    /**
     * The AppID of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ConnectorID of the connector that we are confirming the sync for.
     *
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * The completed lifecycle id of the most recent sync we want to validate
     *
     * @generated from protobuf field: string sync_lifecycle_id = 3;
     */
    syncLifecycleId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConfirmSyncValidResponse
 */
export interface ConfirmSyncValidResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.PauseSyncRequest
 */
export interface PauseSyncRequest {
    /**
     * The AppID of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ConnectorID of the connector that we are pausing the sync for.
     *
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.PauseSyncResponse
 */
export interface PauseSyncResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.C1AppConfig
 */
export interface C1AppConfig {
}
/**
 * @generated from protobuf message c1.api.app.v1.FileConfig
 */
export interface FileConfig {
    /**
     * @generated from protobuf field: c1.api.filestore.v1.File file = 1;
     */
    file?: File;
    /**
     * Map of KNOWN_COLUMNS -> FILE_COLUMNS
     *
     * @generated from protobuf field: map<string, string> column_map = 2;
     */
    columnMap: {
        [key: string]: string;
    };
    /**
     * List of all FILE_COLUMNS
     *
     * @generated from protobuf field: repeated string available_columns = 3;
     */
    availableColumns: string[];
    /**
     * Map of SPREADSHEET_COLUMNS -> USER_PROFILE_ATTRIBUTES
     *
     * @generated from protobuf field: map<string, string> profile_attribute_map = 4;
     */
    profileAttributeMap: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.KeyValueItem
 */
export interface KeyValueItem {
    /**
     * @generated from protobuf field: string key = 1;
     */
    key: string;
    /**
     * @generated from protobuf field: string value = 2;
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.KeyValues
 */
export interface KeyValues {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.KeyValueItem items = 1;
     */
    items: KeyValueItem[];
}
/**
 * @generated from protobuf message c1.api.app.v1.StringMap
 */
export interface StringMap {
    /**
     * @generated from protobuf field: map<string, string> items = 1;
     */
    items: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.EnvValue
 */
export interface EnvValue {
    /**
     * @generated from protobuf oneof: value
     */
    value: {
        oneofKind: "stringValue";
        /**
         * @generated from protobuf field: string string_value = 1;
         */
        stringValue: string;
    } | {
        oneofKind: "keyValues";
        /**
         * @generated from protobuf field: c1.api.app.v1.KeyValues key_values = 2;
         */
        keyValues: KeyValues;
    } | {
        oneofKind: "stringMap";
        /**
         * @generated from protobuf field: c1.api.app.v1.StringMap string_map = 3;
         */
        stringMap: StringMap;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.EnvConfig
 */
export interface EnvConfig {
    /**
     * @generated from protobuf field: map<string, c1.api.app.v1.EnvValue> configuration = 12;
     */
    configuration: {
        [key: string]: EnvValue;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.Option
 */
export interface Option {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string value = 3;
     */
    value: string;
}
/**
 * The ConnectorExpandMask is used to expand related objects on a connector.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorExpandMask
 */
export interface ConnectorExpandMask {
    /**
     * Paths that you want expanded in the response. Possible values are "app_id" and "*".
     *
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * OAuth2AuthorizedAs tracks the user that OAuthed with the connector.
 *
 * @generated from protobuf message c1.api.app.v1.OAuth2AuthorizedAs
 */
export interface OAuth2AuthorizedAs {
    /**
     * authEmail is the email of the user that authorized the connector using OAuth.
     *
     * @generated from protobuf field: string auth_email = 1;
     */
    authEmail: string;
    /**
     * authorizedAt is the timestamp of when the connector was authorized with OAuth.
     *
     * @generated from protobuf field: google.protobuf.Timestamp authorized_at = 2;
     */
    authorizedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.SyncConfig
 */
export interface SyncConfig {
    /**
     * @generated from protobuf field: repeated string sync_resource_type_ids = 21;
     */
    syncResourceTypeIds: string[];
}
/**
 * A Connector is used to sync objects into Apps
 *
 * @generated from protobuf message c1.api.app.v1.Connector
 */
export interface Connector {
    /**
     * The id of the app the connector is associated with.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The id of the connector.
     *
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the connector was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the connector was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the connector was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
    /**
     * The display name of the connector.
     *
     * @generated from protobuf field: string display_name = 6;
     */
    displayName: string;
    /**
     * The description of the connector.
     *
     * @generated from protobuf field: string description = 7;
     */
    description: string;
    /**
     * Contains an arbitrary serialized message along with a @type that describes the type of the serialized message.
     * ONLY contains a FileConfig or EnvConfig
     *
     * @generated from protobuf field: google.protobuf.Any config = 8;
     */
    config?: Any;
    /**
     * The downloadUrl for a spreadsheet if the connector was created from uploading a file.
     *
     * @generated from protobuf field: string download_url = 9;
     */
    downloadUrl: string;
    /**
     * The catalogId describes which catalog entry this connector is an instance of. For example, every Okta connector will have the same catalogId indicating it is an Okta connector.
     *
     * @generated from protobuf field: string catalog_id = 10;
     */
    catalogId: string;
    /**
     * If the connector requires authenticating with OAuth, this field is used to track the authenticated user.
     *
     * @generated from protobuf field: c1.api.app.v1.OAuth2AuthorizedAs oauth_authorized_as = 11;
     */
    oauthAuthorizedAs?: OAuth2AuthorizedAs;
    /**
     * The status field on the connector is used to track the status of the connectors sync, and when syncing last started, completed, or caused the connector to update.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorStatus status = 12;
     */
    status?: ConnectorStatus;
    /**
     * The userIds field is used to define the integration owners of the connector.
     *
     * @generated from protobuf field: repeated string user_ids = 13;
     */
    userIds: string[];
    /**
     * The datetime, in RFC3339 format, of when sync for the connector was disabled.
     *
     * @generated from protobuf field: google.protobuf.Timestamp sync_disabled_at = 14;
     */
    syncDisabledAt?: Timestamp;
    /**
     * The reason the connector sync was disabled.
     *
     * @generated from protobuf field: string sync_disabled_reason = 15;
     */
    syncDisabledReason: string;
    /**
     * The category of the connector sync that was disabled.
     *
     * @generated from protobuf field: string sync_disabled_category = 16;
     */
    syncDisabledCategory: string;
    /**
     * List of profile attributes to sync, when set only these attributes will be synced
     *
     * @generated from protobuf field: repeated string profile_allow_list = 17;
     */
    profileAllowList: string[];
    /**
     * List of profile attributes to ignore (not sync), when set other attributes will be synced, but these will not.
     *
     * @generated from protobuf field: repeated string profile_ignore_list = 18;
     */
    profileIgnoreList: string[];
    /**
     * @generated from protobuf field: bool disable_check_bad_sync = 19;
     */
    disableCheckBadSync: boolean;
    /**
     * @generated from protobuf field: bool can_resume_sync = 20;
     */
    canResumeSync: boolean;
    /**
     * @generated from protobuf field: c1.api.app.v1.SyncConfig sync_config = 21;
     */
    syncConfig?: SyncConfig;
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorSyncCronSchedule connector_sync_cron_schedule = 22;
     */
    connectorSyncCronSchedule?: ConnectorSyncCronSchedule;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorRef
 */
export interface ConnectorRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * The status field on the connector is used to track the status of the connectors sync, and when syncing last started, completed, or caused the connector to update.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorStatus
 */
export interface ConnectorStatus {
    /**
     * The status of the connector sync.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorStatus.SyncStatus status = 1;
     */
    status: ConnectorStatus_SyncStatus;
    /**
     * The last error encountered by the connector.
     *
     * @generated from protobuf field: string last_error = 2;
     */
    lastError: string;
    /**
     * A timestamp, in RFC3339 format, when the connector's most recently sync started at.
     *
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 3;
     */
    startedAt?: Timestamp;
    /**
     * A timestamp, in RFC3339 format, when the connector's most recently sync status updated at.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * A timestamp, in RFC3339 format, when the connector's most recently sync completed at.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 5;
     */
    completedAt?: Timestamp;
}
/**
 * @generated from protobuf enum c1.api.app.v1.ConnectorStatus.SyncStatus
 */
export enum ConnectorStatus_SyncStatus {
    /**
     * Sync status unspecified. If returned in a get response this should be considered invalid.
     *
     * @generated from protobuf enum value: SYNC_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Sync is running.
     *
     * @generated from protobuf enum value: SYNC_STATUS_RUNNING = 1;
     */
    RUNNING = 1,
    /**
     * Sync is done.
     *
     * @generated from protobuf enum value: SYNC_STATUS_DONE = 2;
     */
    DONE = 2,
    /**
     * Sync encountered an error.
     *
     * @generated from protobuf enum value: SYNC_STATUS_ERROR = 3;
     */
    ERROR = 3,
    /**
     * Sync is disabled
     *
     * @generated from protobuf enum value: SYNC_STATUS_DISABLED = 4;
     */
    DISABLED = 4
}
/**
 * The ConnectorView object provides a connector response object, as well as JSONPATHs to related objects provided by expanders.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorView
 */
export interface ConnectorView {
    /**
     * The connector object being returned by the request.
     *
     * @generated from protobuf field: c1.api.app.v1.Connector connector = 1;
     */
    connector?: Connector;
    /**
     * JSONPATH expression indicating the location of the App object in the expanded array.
     *
     * @generated from protobuf field: string app_path = 3;
     */
    appPath: string;
    /**
     * JSONPATH expression indicating the location of the User object in the expanded array. This is the user that is a direct target of the ticket without a specific relationship to a potentially non-existent app user.
     *
     * @generated from protobuf field: string users_path = 4;
     */
    usersPath: string;
    /**
     * JSONPATH expression indicating the location of the ConnectorCapabilities object in the expanded array.
     *
     * @generated from protobuf field: string capabilities_path = 5;
     */
    capabilitiesPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceCreateRequest
 */
export interface ConnectorServiceCreateRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: google.protobuf.Any config = 4;
     */
    config?: Any;
    /**
     * @generated from protobuf field: string catalog_id = 5;
     */
    catalogId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 6;
     */
    expandMask?: ConnectorExpandMask;
    /**
     * @generated from protobuf field: repeated string user_ids = 7;
     */
    userIds: string[];
}
/**
 * The ConnectorServiceCreateDelegatedRequest message contains the fields required to create a connector.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceCreateDelegatedRequest
 */
export interface ConnectorServiceCreateDelegatedRequest {
    /**
     * The displayName of the connector.
     *
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * The description of the connector.
     *
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * The catalogId describes which catalog entry this connector is an instance of. For example, every Okta connector will have the same catalogId indicating it is an Okta connector.
     *
     * @generated from protobuf field: string catalog_id = 3;
     */
    catalogId: string;
    /**
     * The appId of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 4;
     */
    appId: string;
    /**
     * The userIds field is used to define the integration owners of the connector.
     *
     * @generated from protobuf field: repeated string user_ids = 5;
     */
    userIds: string[];
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 6;
     */
    expandMask?: ConnectorExpandMask;
    /**
     * For promoting from an unmanaged app
     *
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingRef app_managed_state_binding_ref = 7;
     */
    appManagedStateBindingRef?: AppManagedStateBindingRef;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAuthorizeURLRequest
 */
export interface CreateAuthorizeURLRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAuthorizeURLResponse
 */
export interface CreateAuthorizeURLResponse {
    /**
     * @generated from protobuf field: string authorization_url = 1;
     */
    authorizationUrl: string;
}
/**
 * The ConnectorServiceGetResponse message contains the connectorView, and an expand mask.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceGetResponse
 */
export interface ConnectorServiceGetResponse {
    /**
     * The connector view contains the connector and paths to objects referenced by the connector.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorView connector_view = 1;
     */
    connectorView?: ConnectorView;
    /**
     * The array of expanded items indicated by the request.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * The ConnectorServiceCreateResponse is the response returned from creating a connector.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceCreateResponse
 */
export interface ConnectorServiceCreateResponse {
    /**
     * The connector view returned by a create request.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorView connector_view = 1;
     */
    connectorView?: ConnectorView;
    /**
     * The array of expanded items indicated by the request.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * The ConnectorServiceUpdateRequest message contains the fields required to update a connector.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUpdateRequest
 */
export interface ConnectorServiceUpdateRequest {
    /**
     * The connector object where the fields to update are set.
     *
     * @generated from protobuf field: c1.api.app.v1.Connector connector = 1;
     */
    connector?: Connector;
    /**
     * A comma-separated list of fields to update. If empty, all fields will be updated.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 3;
     */
    expandMask?: ConnectorExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUpdateAllowIgnoreListRequest
 */
export interface ConnectorServiceUpdateAllowIgnoreListRequest {
    /**
     * The connector object where the fields to update are set.
     *
     * @generated from protobuf field: c1.api.app.v1.Connector connector = 1;
     */
    connector?: Connector;
    /**
     * A comma-separated list of fields to update. If empty, all fields will be updated.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 3;
     */
    expandMask?: ConnectorExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUpdateSyncResourceTypesConfigRequest
 */
export interface ConnectorServiceUpdateSyncResourceTypesConfigRequest {
    /**
     * The connector object where the fields to update are set.
     *
     * @generated from protobuf field: c1.api.app.v1.Connector connector = 1;
     */
    connector?: Connector;
    /**
     * A comma-separated list of fields to update. If empty, all fields will be updated.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 3;
     */
    expandMask?: ConnectorExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUpdateAdvancedConfigRequest
 */
export interface ConnectorServiceUpdateAdvancedConfigRequest {
    /**
     * The connector object where the fields to update are set.
     *
     * @generated from protobuf field: c1.api.app.v1.Connector connector = 1;
     */
    connector?: Connector;
    /**
     * A comma-separated list of fields to update. If empty, all fields will be updated.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 3;
     */
    expandMask?: ConnectorExpandMask;
}
/**
 * The ConnectorServiceUpdateDelegatedRequest message contains the fields required to update a connector.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUpdateDelegatedRequest
 */
export interface ConnectorServiceUpdateDelegatedRequest {
    /**
     * The connector object where the fields to update are set.
     *
     * @generated from protobuf field: c1.api.app.v1.Connector connector = 1;
     */
    connector?: Connector;
    /**
     * A comma-separated list of fields to update. If empty, all fields will be updated.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 3;
     */
    expandMask?: ConnectorExpandMask;
}
/**
 * ConnectorServiceUpdateResponse is the response returned by the update method.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUpdateResponse
 */
export interface ConnectorServiceUpdateResponse {
    /**
     * The connector view returned by an update.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorView connector_view = 1;
     */
    connectorView?: ConnectorView;
    /**
     * The array of expanded items indicated by the request.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * ConnectorServiceGetRequest is the request message for the get method.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceGetRequest
 */
export interface ConnectorServiceGetRequest {
    /**
     * The appId of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The id of the connector.
     *
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 3;
     */
    expandMask?: ConnectorExpandMask;
}
/**
 * ConnectorServiceDeleteRequest is a request for deleting a connector. It uses URL values for input.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceDeleteRequest
 */
export interface ConnectorServiceDeleteRequest {
    /**
     * The appId of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The id of the connector.
     *
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * Empty response body. Status code indicates success.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceDeleteResponse
 */
export interface ConnectorServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceListRequest
 */
export interface ConnectorServiceListRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 4;
     */
    expandMask?: ConnectorExpandMask;
}
/**
 * The ConnectorServiceListResponse message contains a list of results and a nextPageToken if applicable
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceListResponse
 */
export interface ConnectorServiceListResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request
     *
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorView list = 1;
     */
    list: ConnectorView[];
    /**
     * List of serialized related objects
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceLogsRequest
 */
export interface ConnectorServiceLogsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorLog
 */
export interface ConnectorLog {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: string msg = 3;
     */
    msg: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct fields = 4;
     */
    fields?: Struct;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceLogsResponse
 */
export interface ConnectorServiceLogsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorLog list = 1;
     */
    list: ConnectorLog[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorConfigFieldActivity
 */
export interface ConnectorConfigFieldActivity {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string field_name = 3;
     */
    fieldName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 7;
     */
    expiresAt?: Timestamp;
    /**
     * @generated from protobuf field: string error = 8;
     */
    error: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.Option options = 9;
     */
    options: Option[];
    /**
     * @generated from protobuf field: c1.api.app.v1.FieldActivityState state = 10;
     */
    state: FieldActivityState;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetConnectorConfigFieldActivityRequest
 */
export interface GetConnectorConfigFieldActivityRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string field_name = 3;
     */
    fieldName: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetConnectorConfigFieldActivityResponse
 */
export interface GetConnectorConfigFieldActivityResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorConfigFieldActivity item = 1;
     */
    item?: ConnectorConfigFieldActivity;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorSyncLifecycle
 */
export interface ConnectorSyncLifecycle {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorSyncLifecycleStatus status = 6;
     */
    status: ConnectorSyncLifecycleStatus;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sync_started_at = 7;
     */
    syncStartedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sync_completed_at = 8;
     */
    syncCompletedAt?: Timestamp;
    /**
     * @generated from protobuf field: map<string, int64> stats = 9;
     */
    stats: {
        [key: string]: number;
    };
    /**
     * @generated from protobuf field: string c1z_sync_id = 10 [json_name = "c1zSyncId"];
     */
    c1ZSyncId: string;
    /**
     * @generated from protobuf field: string sync_type = 11;
     */
    syncType: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp processing_started_at = 12;
     */
    processingStartedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp processing_completed_at = 13;
     */
    processingCompletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorSyncLifecycleRef
 */
export interface ConnectorSyncLifecycleRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetConnectorAccountCreationSchemaRequest
 */
export interface GetConnectorAccountCreationSchemaRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetConnectorAccountCreationSchemaResponse
 */
export interface GetConnectorAccountCreationSchemaResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorAccountCreationSchema account_creation_schema = 1;
     */
    accountCreationSchema?: ConnectorAccountCreationSchema;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorAccountCreationSchema
 */
export interface ConnectorAccountCreationSchema {
    /**
     * @generated from protobuf field: string tenant_id = 1;
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string id = 4;
     */
    id: string;
    /**
     * @generated from protobuf field: map<string, c1.api.app.v1.ConnectorAccountCreationSchema.Field> field_map = 5;
     */
    fieldMap: {
        [key: string]: ConnectorAccountCreationSchema_Field;
    };
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 8;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.Field
 */
export interface ConnectorAccountCreationSchema_Field {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: bool required = 2;
     */
    required: boolean;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string placeholder = 4;
     */
    placeholder: string;
    /**
     * @generated from protobuf field: int32 order = 5;
     */
    order: number;
    /**
     * @generated from protobuf field: bool deprecated = 6;
     */
    deprecated: boolean;
    /**
     * @generated from protobuf oneof: field
     */
    field: {
        oneofKind: "str";
        /**
         * @generated from protobuf field: c1.api.app.v1.ConnectorAccountCreationSchema.StringField str = 100;
         */
        str: ConnectorAccountCreationSchema_StringField;
    } | {
        oneofKind: "bool";
        /**
         * @generated from protobuf field: c1.api.app.v1.ConnectorAccountCreationSchema.BoolField bool = 101;
         */
        bool: ConnectorAccountCreationSchema_BoolField;
    } | {
        oneofKind: "strList";
        /**
         * @generated from protobuf field: c1.api.app.v1.ConnectorAccountCreationSchema.StringListField str_list = 102;
         */
        strList: ConnectorAccountCreationSchema_StringListField;
    } | {
        oneofKind: "i";
        /**
         * @generated from protobuf field: c1.api.app.v1.ConnectorAccountCreationSchema.IntField i = 103;
         */
        i: ConnectorAccountCreationSchema_IntField;
    } | {
        oneofKind: "m";
        /**
         * @generated from protobuf field: c1.api.app.v1.ConnectorAccountCreationSchema.MapField m = 104;
         */
        m: ConnectorAccountCreationSchema_MapField;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.StringField
 */
export interface ConnectorAccountCreationSchema_StringField {
    /**
     * @generated from protobuf field: optional string default_value = 1;
     */
    defaultValue?: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.BoolField
 */
export interface ConnectorAccountCreationSchema_BoolField {
    /**
     * @generated from protobuf field: optional bool default_value = 1;
     */
    defaultValue?: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.StringListField
 */
export interface ConnectorAccountCreationSchema_StringListField {
    /**
     * @generated from protobuf field: repeated string default_value = 1;
     */
    defaultValue: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.IntField
 */
export interface ConnectorAccountCreationSchema_IntField {
    /**
     * @generated from protobuf field: optional int32 default_value = 1;
     */
    defaultValue?: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.MapField
 */
export interface ConnectorAccountCreationSchema_MapField {
    /**
     * @generated from protobuf field: map<string, c1.api.app.v1.ConnectorAccountCreationSchema.Field> default_value = 1;
     */
    defaultValue: {
        [key: string]: ConnectorAccountCreationSchema_Field;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorExternalSourceConfigSetRequest
 */
export interface ConnectorExternalSourceConfigSetRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string external_app_id = 3;
     */
    externalAppId: string;
    /**
     * @generated from protobuf field: string external_connector_id = 4;
     */
    externalConnectorId: string;
    /**
     * @generated from protobuf field: string external_app_entitlement_filter_id = 5;
     */
    externalAppEntitlementFilterId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorExternalSourceConfig
 */
export interface ConnectorExternalSourceConfig {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string external_app_id = 3;
     */
    externalAppId: string;
    /**
     * @generated from protobuf field: string external_connector_id = 4;
     */
    externalConnectorId: string;
    /**
     * @generated from protobuf field: string external_app_entitlement_filter_id = 5;
     */
    externalAppEntitlementFilterId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 8;
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorExternalSourceConfigGetRequest
 */
export interface ConnectorExternalSourceConfigGetRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListCompletedConnectorSyncLifecycleRequest
 */
export interface ListCompletedConnectorSyncLifecycleRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListCompletedConnectorSyncLifecycleResponse
 */
export interface ListCompletedConnectorSyncLifecycleResponse {
    /**
     * The list of connector sync lifecycles
     *
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorSyncLifecycle list = 1;
     */
    list: ConnectorSyncLifecycle[];
    /**
     * Token to retrieve the next page of results, or empty if there are no more results.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetConnectorSyncDownloadURLRequest
 */
export interface GetConnectorSyncDownloadURLRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string sync_id = 3;
     */
    syncId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetConnectorSyncDownloadURLResponse
 */
export interface GetConnectorSyncDownloadURLResponse {
    /**
     * Short-lived download URL for the connector sync artifact
     *
     * @generated from protobuf field: string download_url = 1;
     */
    downloadUrl: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListConnectorSyncLifecycleRequest
 */
export interface ListConnectorSyncLifecycleRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListConnectorSyncLifecycleResponse
 */
export interface ListConnectorSyncLifecycleResponse {
    /**
     * The list of connector sync lifecycles
     *
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorSyncLifecycle list = 1;
     */
    list: ConnectorSyncLifecycle[];
    /**
     * Token to retrieve the next page of results, or empty if there are no more results.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.EditorValidateRequest
 */
export interface EditorValidateRequest {
    /**
     * @generated from protobuf field: string text = 1;
     */
    text: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.EditorValidateResponse
 */
export interface EditorValidateResponse {
    /**
     * @generated from protobuf field: repeated c1.api.editor.v1.EditorMarker markers = 1;
     */
    markers: EditorMarker[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorScheduleCron
 */
export interface ConnectorScheduleCron {
    /**
     * @generated from protobuf field: string cron_spec = 1;
     */
    cronSpec: string;
    /**
     * @generated from protobuf field: string timezone = 2;
     */
    timezone: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.UpdateConnectorScheduleRequest
 */
export interface UpdateConnectorScheduleRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf oneof: schedule
     */
    schedule: {
        oneofKind: "cron";
        /**
         * @generated from protobuf field: c1.api.app.v1.ConnectorScheduleCron cron = 100;
         */
        cron: ConnectorScheduleCron;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.UpdateConnectorScheduleResponse
 */
export interface UpdateConnectorScheduleResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorSyncCronSchedule
 */
export interface ConnectorSyncCronSchedule {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start = 1;
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: string cron_spec = 2;
     */
    cronSpec: string;
    /**
     * @generated from protobuf field: string timezone = 3;
     */
    timezone: string;
}
/**
 * @generated from protobuf enum c1.api.app.v1.FieldActivityState
 */
export enum FieldActivityState {
    /**
     * @generated from protobuf enum value: FIELD_ACTIVITY_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FIELD_ACTIVITY_STATE_CREATED = 1;
     */
    CREATED = 1,
    /**
     * @generated from protobuf enum value: FIELD_ACTIVITY_STATE_PENDING = 2;
     */
    PENDING = 2,
    /**
     * @generated from protobuf enum value: FIELD_ACTIVITY_STATE_DONE = 3;
     */
    DONE = 3,
    /**
     * @generated from protobuf enum value: FIELD_ACTIVITY_STATE_ERROR = 4;
     */
    ERROR = 4
}
/**
 * @generated from protobuf enum c1.api.app.v1.ConnectorSyncLifecycleStatus
 */
export enum ConnectorSyncLifecycleStatus {
    /**
     * @generated from protobuf enum value: SYNC_LIFECYCLE_STATUS_UNSPECIFIED = 0;
     */
    SYNC_LIFECYCLE_STATUS_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SYNC_LIFECYCLE_STATUS_SYNCING = 1;
     */
    SYNC_LIFECYCLE_STATUS_SYNCING = 1,
    /**
     * @generated from protobuf enum value: SYNC_LIFECYCLE_STATUS_ERRORED = 2;
     */
    SYNC_LIFECYCLE_STATUS_ERRORED = 2,
    /**
     * @generated from protobuf enum value: SYNC_LIFECYCLE_STATUS_COMPLETED = 3;
     */
    SYNC_LIFECYCLE_STATUS_COMPLETED = 3,
    /**
     * @generated from protobuf enum value: SYNC_LIFECYCLE_STATUS_NOT_CONNECTED = 4;
     */
    SYNC_LIFECYCLE_STATUS_NOT_CONNECTED = 4,
    /**
     * @generated from protobuf enum value: SYNC_LIFECYCLE_STATUS_SKIPPED = 5;
     */
    SYNC_LIFECYCLE_STATUS_SKIPPED = 5,
    /**
     * @generated from protobuf enum value: SYNC_LIFECYCLE_STATUS_ERRORED_NO_DATA = 6;
     */
    SYNC_LIFECYCLE_STATUS_ERRORED_NO_DATA = 6
}
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorSyncLifecycleRequest$Type extends MessageType<GetConnectorSyncLifecycleRequest> {
    constructor() {
        super("c1.api.app.v1.GetConnectorSyncLifecycleRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetConnectorSyncLifecycleRequest
 */
export const GetConnectorSyncLifecycleRequest = new GetConnectorSyncLifecycleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCredential$Type extends MessageType<ConnectorCredential> {
    constructor() {
        super("c1.api.app.v1.ConnectorCredential", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "last_used_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "expires_time", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 10, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "ConnectorCredential" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorCredential
 */
export const ConnectorCredential = new ConnectorCredential$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceGetCredentialsRequest$Type extends MessageType<ConnectorServiceGetCredentialsRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceGetCredentialsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "8", maxLen: "64" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceGetCredentialsRequest
 */
export const ConnectorServiceGetCredentialsRequest = new ConnectorServiceGetCredentialsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceGetCredentialsResponse$Type extends MessageType<ConnectorServiceGetCredentialsResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceGetCredentialsResponse", [
            { no: 1, name: "credential", kind: "message", T: () => ConnectorCredential }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceGetCredentialsResponse
 */
export const ConnectorServiceGetCredentialsResponse = new ConnectorServiceGetCredentialsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceRotateCredentialResponse$Type extends MessageType<ConnectorServiceRotateCredentialResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceRotateCredentialResponse", [
            { no: 1, name: "credential", kind: "message", T: () => ConnectorCredential }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceRotateCredentialResponse
 */
export const ConnectorServiceRotateCredentialResponse = new ConnectorServiceRotateCredentialResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceListCredentialsRequest$Type extends MessageType<ConnectorServiceListCredentialsRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceListCredentialsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceListCredentialsRequest
 */
export const ConnectorServiceListCredentialsRequest = new ConnectorServiceListCredentialsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceListCredentialsResponse$Type extends MessageType<ConnectorServiceListCredentialsResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceListCredentialsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorCredential },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceListCredentialsResponse
 */
export const ConnectorServiceListCredentialsResponse = new ConnectorServiceListCredentialsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceRotateCredentialRequest$Type extends MessageType<ConnectorServiceRotateCredentialRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceRotateCredentialRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "ConnectorCredential" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceRotateCredentialRequest
 */
export const ConnectorServiceRotateCredentialRequest = new ConnectorServiceRotateCredentialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceRevokeCredentialRequest$Type extends MessageType<ConnectorServiceRevokeCredentialRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceRevokeCredentialRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "8", maxLen: "64" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "ConnectorCredential" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceRevokeCredentialRequest
 */
export const ConnectorServiceRevokeCredentialRequest = new ConnectorServiceRevokeCredentialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceRevokeCredentialResponse$Type extends MessageType<ConnectorServiceRevokeCredentialResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceRevokeCredentialResponse", [], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "ConnectorCredential" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceRevokeCredentialResponse
 */
export const ConnectorServiceRevokeCredentialResponse = new ConnectorServiceRevokeCredentialResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUploadRequest$Type extends MessageType<ConnectorServiceUploadRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUploadRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUploadRequest
 */
export const ConnectorServiceUploadRequest = new ConnectorServiceUploadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUploadResponse$Type extends MessageType<ConnectorServiceUploadResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUploadResponse", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUploadResponse
 */
export const ConnectorServiceUploadResponse = new ConnectorServiceUploadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForceSyncRequest$Type extends MessageType<ForceSyncRequest> {
    constructor() {
        super("c1.api.app.v1.ForceSyncRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ForceSyncRequest
 */
export const ForceSyncRequest = new ForceSyncRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForceSyncResponse$Type extends MessageType<ForceSyncResponse> {
    constructor() {
        super("c1.api.app.v1.ForceSyncResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ForceSyncResponse
 */
export const ForceSyncResponse = new ForceSyncResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResumeSyncRequest$Type extends MessageType<ResumeSyncRequest> {
    constructor() {
        super("c1.api.app.v1.ResumeSyncRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ResumeSyncRequest
 */
export const ResumeSyncRequest = new ResumeSyncRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResumeSyncResponse$Type extends MessageType<ResumeSyncResponse> {
    constructor() {
        super("c1.api.app.v1.ResumeSyncResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ResumeSyncResponse
 */
export const ResumeSyncResponse = new ResumeSyncResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfirmSyncValidRequest$Type extends MessageType<ConfirmSyncValidRequest> {
    constructor() {
        super("c1.api.app.v1.ConfirmSyncValidRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "sync_lifecycle_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConfirmSyncValidRequest
 */
export const ConfirmSyncValidRequest = new ConfirmSyncValidRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfirmSyncValidResponse$Type extends MessageType<ConfirmSyncValidResponse> {
    constructor() {
        super("c1.api.app.v1.ConfirmSyncValidResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConfirmSyncValidResponse
 */
export const ConfirmSyncValidResponse = new ConfirmSyncValidResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PauseSyncRequest$Type extends MessageType<PauseSyncRequest> {
    constructor() {
        super("c1.api.app.v1.PauseSyncRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.PauseSyncRequest
 */
export const PauseSyncRequest = new PauseSyncRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PauseSyncResponse$Type extends MessageType<PauseSyncResponse> {
    constructor() {
        super("c1.api.app.v1.PauseSyncResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.PauseSyncResponse
 */
export const PauseSyncResponse = new PauseSyncResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class C1AppConfig$Type extends MessageType<C1AppConfig> {
    constructor() {
        super("c1.api.app.v1.C1AppConfig", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.C1AppConfig
 */
export const C1AppConfig = new C1AppConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileConfig$Type extends MessageType<FileConfig> {
    constructor() {
        super("c1.api.app.v1.FileConfig", [
            { no: 1, name: "file", kind: "message", T: () => File },
            { no: 2, name: "column_map", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 3, name: "available_columns", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "profile_attribute_map", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.FileConfig
 */
export const FileConfig = new FileConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KeyValueItem$Type extends MessageType<KeyValueItem> {
    constructor() {
        super("c1.api.app.v1.KeyValueItem", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.KeyValueItem
 */
export const KeyValueItem = new KeyValueItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KeyValues$Type extends MessageType<KeyValues> {
    constructor() {
        super("c1.api.app.v1.KeyValues", [
            { no: 1, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => KeyValueItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.KeyValues
 */
export const KeyValues = new KeyValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StringMap$Type extends MessageType<StringMap> {
    constructor() {
        super("c1.api.app.v1.StringMap", [
            { no: 1, name: "items", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.StringMap
 */
export const StringMap = new StringMap$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnvValue$Type extends MessageType<EnvValue> {
    constructor() {
        super("c1.api.app.v1.EnvValue", [
            { no: 1, name: "string_value", kind: "scalar", oneof: "value", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "key_values", kind: "message", oneof: "value", T: () => KeyValues },
            { no: 3, name: "string_map", kind: "message", oneof: "value", T: () => StringMap }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EnvValue
 */
export const EnvValue = new EnvValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnvConfig$Type extends MessageType<EnvConfig> {
    constructor() {
        super("c1.api.app.v1.EnvConfig", [
            { no: 12, name: "configuration", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => EnvValue } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EnvConfig
 */
export const EnvConfig = new EnvConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Option$Type extends MessageType<Option> {
    constructor() {
        super("c1.api.app.v1.Option", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.Option
 */
export const Option = new Option$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorExpandMask$Type extends MessageType<ConnectorExpandMask> {
    constructor() {
        super("c1.api.app.v1.ConnectorExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorExpandMask
 */
export const ConnectorExpandMask = new ConnectorExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OAuth2AuthorizedAs$Type extends MessageType<OAuth2AuthorizedAs> {
    constructor() {
        super("c1.api.app.v1.OAuth2AuthorizedAs", [
            { no: 1, name: "auth_email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "authorized_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.OAuth2AuthorizedAs
 */
export const OAuth2AuthorizedAs = new OAuth2AuthorizedAs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncConfig$Type extends MessageType<SyncConfig> {
    constructor() {
        super("c1.api.app.v1.SyncConfig", [
            { no: 21, name: "sync_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SyncConfig
 */
export const SyncConfig = new SyncConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Connector$Type extends MessageType<Connector> {
    constructor() {
        super("c1.api.app.v1.Connector", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "512" } } } },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } },
            { no: 8, name: "config", kind: "message", T: () => Any },
            { no: 9, name: "download_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "oauth_authorized_as", kind: "message", T: () => OAuth2AuthorizedAs, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "status", kind: "message", T: () => ConnectorStatus, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "sync_disabled_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 15, name: "sync_disabled_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "sync_disabled_category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "profile_allow_list", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "profile_ignore_list", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "disable_check_bad_sync", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "can_resume_sync", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "sync_config", kind: "message", T: () => SyncConfig },
            { no: 22, name: "connector_sync_cron_schedule", kind: "message", T: () => ConnectorSyncCronSchedule }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.Connector
 */
export const Connector = new Connector$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorRef$Type extends MessageType<ConnectorRef> {
    constructor() {
        super("c1.api.app.v1.ConnectorRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorRef
 */
export const ConnectorRef = new ConnectorRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorStatus$Type extends MessageType<ConnectorStatus> {
    constructor() {
        super("c1.api.app.v1.ConnectorStatus", [
            { no: 1, name: "status", kind: "enum", T: () => ["c1.api.app.v1.ConnectorStatus.SyncStatus", ConnectorStatus_SyncStatus, "SYNC_STATUS_"] },
            { no: 2, name: "last_error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "started_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "completed_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorStatus
 */
export const ConnectorStatus = new ConnectorStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorView$Type extends MessageType<ConnectorView> {
    constructor() {
        super("c1.api.app.v1.ConnectorView", [
            { no: 1, name: "connector", kind: "message", T: () => Connector },
            { no: 3, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "users_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "capabilities_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorView
 */
export const ConnectorView = new ConnectorView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceCreateRequest$Type extends MessageType<ConnectorServiceCreateRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceCreateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } },
            { no: 4, name: "config", kind: "message", T: () => Any },
            { no: 5, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask },
            { no: 7, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceCreateRequest
 */
export const ConnectorServiceCreateRequest = new ConnectorServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceCreateDelegatedRequest$Type extends MessageType<ConnectorServiceCreateDelegatedRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceCreateDelegatedRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 5, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask },
            { no: 7, name: "app_managed_state_binding_ref", kind: "message", T: () => AppManagedStateBindingRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceCreateDelegatedRequest
 */
export const ConnectorServiceCreateDelegatedRequest = new ConnectorServiceCreateDelegatedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAuthorizeURLRequest$Type extends MessageType<CreateAuthorizeURLRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAuthorizeURLRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAuthorizeURLRequest
 */
export const CreateAuthorizeURLRequest = new CreateAuthorizeURLRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAuthorizeURLResponse$Type extends MessageType<CreateAuthorizeURLResponse> {
    constructor() {
        super("c1.api.app.v1.CreateAuthorizeURLResponse", [
            { no: 1, name: "authorization_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAuthorizeURLResponse
 */
export const CreateAuthorizeURLResponse = new CreateAuthorizeURLResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceGetResponse$Type extends MessageType<ConnectorServiceGetResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceGetResponse", [
            { no: 1, name: "connector_view", kind: "message", T: () => ConnectorView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceGetResponse
 */
export const ConnectorServiceGetResponse = new ConnectorServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceCreateResponse$Type extends MessageType<ConnectorServiceCreateResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceCreateResponse", [
            { no: 1, name: "connector_view", kind: "message", T: () => ConnectorView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceCreateResponse
 */
export const ConnectorServiceCreateResponse = new ConnectorServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUpdateRequest$Type extends MessageType<ConnectorServiceUpdateRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUpdateRequest", [
            { no: 1, name: "connector", kind: "message", T: () => Connector, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUpdateRequest
 */
export const ConnectorServiceUpdateRequest = new ConnectorServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUpdateAllowIgnoreListRequest$Type extends MessageType<ConnectorServiceUpdateAllowIgnoreListRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUpdateAllowIgnoreListRequest", [
            { no: 1, name: "connector", kind: "message", T: () => Connector, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUpdateAllowIgnoreListRequest
 */
export const ConnectorServiceUpdateAllowIgnoreListRequest = new ConnectorServiceUpdateAllowIgnoreListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUpdateSyncResourceTypesConfigRequest$Type extends MessageType<ConnectorServiceUpdateSyncResourceTypesConfigRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUpdateSyncResourceTypesConfigRequest", [
            { no: 1, name: "connector", kind: "message", T: () => Connector, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUpdateSyncResourceTypesConfigRequest
 */
export const ConnectorServiceUpdateSyncResourceTypesConfigRequest = new ConnectorServiceUpdateSyncResourceTypesConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUpdateAdvancedConfigRequest$Type extends MessageType<ConnectorServiceUpdateAdvancedConfigRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUpdateAdvancedConfigRequest", [
            { no: 1, name: "connector", kind: "message", T: () => Connector, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUpdateAdvancedConfigRequest
 */
export const ConnectorServiceUpdateAdvancedConfigRequest = new ConnectorServiceUpdateAdvancedConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUpdateDelegatedRequest$Type extends MessageType<ConnectorServiceUpdateDelegatedRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUpdateDelegatedRequest", [
            { no: 1, name: "connector", kind: "message", T: () => Connector, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUpdateDelegatedRequest
 */
export const ConnectorServiceUpdateDelegatedRequest = new ConnectorServiceUpdateDelegatedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUpdateResponse$Type extends MessageType<ConnectorServiceUpdateResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUpdateResponse", [
            { no: 1, name: "connector_view", kind: "message", T: () => ConnectorView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUpdateResponse
 */
export const ConnectorServiceUpdateResponse = new ConnectorServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceGetRequest$Type extends MessageType<ConnectorServiceGetRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceGetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceGetRequest
 */
export const ConnectorServiceGetRequest = new ConnectorServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceDeleteRequest$Type extends MessageType<ConnectorServiceDeleteRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceDeleteRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceDeleteRequest
 */
export const ConnectorServiceDeleteRequest = new ConnectorServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceDeleteResponse$Type extends MessageType<ConnectorServiceDeleteResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceDeleteResponse
 */
export const ConnectorServiceDeleteResponse = new ConnectorServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceListRequest$Type extends MessageType<ConnectorServiceListRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceListRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceListRequest
 */
export const ConnectorServiceListRequest = new ConnectorServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceListResponse$Type extends MessageType<ConnectorServiceListResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceListResponse
 */
export const ConnectorServiceListResponse = new ConnectorServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceLogsRequest$Type extends MessageType<ConnectorServiceLogsRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceLogsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceLogsRequest
 */
export const ConnectorServiceLogsRequest = new ConnectorServiceLogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorLog$Type extends MessageType<ConnectorLog> {
    constructor() {
        super("c1.api.app.v1.ConnectorLog", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "msg", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "fields", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorLog
 */
export const ConnectorLog = new ConnectorLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceLogsResponse$Type extends MessageType<ConnectorServiceLogsResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceLogsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorLog },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceLogsResponse
 */
export const ConnectorServiceLogsResponse = new ConnectorServiceLogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorConfigFieldActivity$Type extends MessageType<ConnectorConfigFieldActivity> {
    constructor() {
        super("c1.api.app.v1.ConnectorConfigFieldActivity", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "field_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "expires_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "options", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Option },
            { no: 10, name: "state", kind: "enum", T: () => ["c1.api.app.v1.FieldActivityState", FieldActivityState, "FIELD_ACTIVITY_STATE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorConfigFieldActivity
 */
export const ConnectorConfigFieldActivity = new ConnectorConfigFieldActivity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorConfigFieldActivityRequest$Type extends MessageType<GetConnectorConfigFieldActivityRequest> {
    constructor() {
        super("c1.api.app.v1.GetConnectorConfigFieldActivityRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "field_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetConnectorConfigFieldActivityRequest
 */
export const GetConnectorConfigFieldActivityRequest = new GetConnectorConfigFieldActivityRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorConfigFieldActivityResponse$Type extends MessageType<GetConnectorConfigFieldActivityResponse> {
    constructor() {
        super("c1.api.app.v1.GetConnectorConfigFieldActivityResponse", [
            { no: 1, name: "item", kind: "message", T: () => ConnectorConfigFieldActivity }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetConnectorConfigFieldActivityResponse
 */
export const GetConnectorConfigFieldActivityResponse = new GetConnectorConfigFieldActivityResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorSyncLifecycle$Type extends MessageType<ConnectorSyncLifecycle> {
    constructor() {
        super("c1.api.app.v1.ConnectorSyncLifecycle", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "status", kind: "enum", T: () => ["c1.api.app.v1.ConnectorSyncLifecycleStatus", ConnectorSyncLifecycleStatus] },
            { no: 7, name: "sync_started_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "sync_completed_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "stats", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "c1z_sync_id", kind: "scalar", jsonName: "c1zSyncId", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "sync_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "processing_started_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "processing_completed_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorSyncLifecycle
 */
export const ConnectorSyncLifecycle = new ConnectorSyncLifecycle$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorSyncLifecycleRef$Type extends MessageType<ConnectorSyncLifecycleRef> {
    constructor() {
        super("c1.api.app.v1.ConnectorSyncLifecycleRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorSyncLifecycleRef
 */
export const ConnectorSyncLifecycleRef = new ConnectorSyncLifecycleRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorAccountCreationSchemaRequest$Type extends MessageType<GetConnectorAccountCreationSchemaRequest> {
    constructor() {
        super("c1.api.app.v1.GetConnectorAccountCreationSchemaRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetConnectorAccountCreationSchemaRequest
 */
export const GetConnectorAccountCreationSchemaRequest = new GetConnectorAccountCreationSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorAccountCreationSchemaResponse$Type extends MessageType<GetConnectorAccountCreationSchemaResponse> {
    constructor() {
        super("c1.api.app.v1.GetConnectorAccountCreationSchemaResponse", [
            { no: 1, name: "account_creation_schema", kind: "message", T: () => ConnectorAccountCreationSchema }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetConnectorAccountCreationSchemaResponse
 */
export const GetConnectorAccountCreationSchemaResponse = new GetConnectorAccountCreationSchemaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema$Type extends MessageType<ConnectorAccountCreationSchema> {
    constructor() {
        super("c1.api.app.v1.ConnectorAccountCreationSchema", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "field_map", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ConnectorAccountCreationSchema_Field } },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorAccountCreationSchema
 */
export const ConnectorAccountCreationSchema = new ConnectorAccountCreationSchema$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_Field$Type extends MessageType<ConnectorAccountCreationSchema_Field> {
    constructor() {
        super("c1.api.app.v1.ConnectorAccountCreationSchema.Field", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "required", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "placeholder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "deprecated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "str", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_StringField },
            { no: 101, name: "bool", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_BoolField },
            { no: 102, name: "str_list", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_StringListField },
            { no: 103, name: "i", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_IntField },
            { no: 104, name: "m", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_MapField }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.Field
 */
export const ConnectorAccountCreationSchema_Field = new ConnectorAccountCreationSchema_Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_StringField$Type extends MessageType<ConnectorAccountCreationSchema_StringField> {
    constructor() {
        super("c1.api.app.v1.ConnectorAccountCreationSchema.StringField", [
            { no: 1, name: "default_value", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.StringField
 */
export const ConnectorAccountCreationSchema_StringField = new ConnectorAccountCreationSchema_StringField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_BoolField$Type extends MessageType<ConnectorAccountCreationSchema_BoolField> {
    constructor() {
        super("c1.api.app.v1.ConnectorAccountCreationSchema.BoolField", [
            { no: 1, name: "default_value", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.BoolField
 */
export const ConnectorAccountCreationSchema_BoolField = new ConnectorAccountCreationSchema_BoolField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_StringListField$Type extends MessageType<ConnectorAccountCreationSchema_StringListField> {
    constructor() {
        super("c1.api.app.v1.ConnectorAccountCreationSchema.StringListField", [
            { no: 1, name: "default_value", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.StringListField
 */
export const ConnectorAccountCreationSchema_StringListField = new ConnectorAccountCreationSchema_StringListField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_IntField$Type extends MessageType<ConnectorAccountCreationSchema_IntField> {
    constructor() {
        super("c1.api.app.v1.ConnectorAccountCreationSchema.IntField", [
            { no: 1, name: "default_value", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.IntField
 */
export const ConnectorAccountCreationSchema_IntField = new ConnectorAccountCreationSchema_IntField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_MapField$Type extends MessageType<ConnectorAccountCreationSchema_MapField> {
    constructor() {
        super("c1.api.app.v1.ConnectorAccountCreationSchema.MapField", [
            { no: 1, name: "default_value", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ConnectorAccountCreationSchema_Field } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.MapField
 */
export const ConnectorAccountCreationSchema_MapField = new ConnectorAccountCreationSchema_MapField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorExternalSourceConfigSetRequest$Type extends MessageType<ConnectorExternalSourceConfigSetRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorExternalSourceConfigSetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "external_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "external_connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "external_app_entitlement_filter_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorExternalSourceConfigSetRequest
 */
export const ConnectorExternalSourceConfigSetRequest = new ConnectorExternalSourceConfigSetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorExternalSourceConfig$Type extends MessageType<ConnectorExternalSourceConfig> {
    constructor() {
        super("c1.api.app.v1.ConnectorExternalSourceConfig", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "external_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "external_app_entitlement_filter_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "deleted_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorExternalSourceConfig
 */
export const ConnectorExternalSourceConfig = new ConnectorExternalSourceConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorExternalSourceConfigGetRequest$Type extends MessageType<ConnectorExternalSourceConfigGetRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorExternalSourceConfigGetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorExternalSourceConfigGetRequest
 */
export const ConnectorExternalSourceConfigGetRequest = new ConnectorExternalSourceConfigGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCompletedConnectorSyncLifecycleRequest$Type extends MessageType<ListCompletedConnectorSyncLifecycleRequest> {
    constructor() {
        super("c1.api.app.v1.ListCompletedConnectorSyncLifecycleRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListCompletedConnectorSyncLifecycleRequest
 */
export const ListCompletedConnectorSyncLifecycleRequest = new ListCompletedConnectorSyncLifecycleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCompletedConnectorSyncLifecycleResponse$Type extends MessageType<ListCompletedConnectorSyncLifecycleResponse> {
    constructor() {
        super("c1.api.app.v1.ListCompletedConnectorSyncLifecycleResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorSyncLifecycle },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListCompletedConnectorSyncLifecycleResponse
 */
export const ListCompletedConnectorSyncLifecycleResponse = new ListCompletedConnectorSyncLifecycleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorSyncDownloadURLRequest$Type extends MessageType<GetConnectorSyncDownloadURLRequest> {
    constructor() {
        super("c1.api.app.v1.GetConnectorSyncDownloadURLRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "sync_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetConnectorSyncDownloadURLRequest
 */
export const GetConnectorSyncDownloadURLRequest = new GetConnectorSyncDownloadURLRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorSyncDownloadURLResponse$Type extends MessageType<GetConnectorSyncDownloadURLResponse> {
    constructor() {
        super("c1.api.app.v1.GetConnectorSyncDownloadURLResponse", [
            { no: 1, name: "download_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetConnectorSyncDownloadURLResponse
 */
export const GetConnectorSyncDownloadURLResponse = new GetConnectorSyncDownloadURLResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConnectorSyncLifecycleRequest$Type extends MessageType<ListConnectorSyncLifecycleRequest> {
    constructor() {
        super("c1.api.app.v1.ListConnectorSyncLifecycleRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListConnectorSyncLifecycleRequest
 */
export const ListConnectorSyncLifecycleRequest = new ListConnectorSyncLifecycleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConnectorSyncLifecycleResponse$Type extends MessageType<ListConnectorSyncLifecycleResponse> {
    constructor() {
        super("c1.api.app.v1.ListConnectorSyncLifecycleResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorSyncLifecycle },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListConnectorSyncLifecycleResponse
 */
export const ListConnectorSyncLifecycleResponse = new ListConnectorSyncLifecycleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditorValidateRequest$Type extends MessageType<EditorValidateRequest> {
    constructor() {
        super("c1.api.app.v1.EditorValidateRequest", [
            { no: 1, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1048576" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EditorValidateRequest
 */
export const EditorValidateRequest = new EditorValidateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditorValidateResponse$Type extends MessageType<EditorValidateResponse> {
    constructor() {
        super("c1.api.app.v1.EditorValidateResponse", [
            { no: 1, name: "markers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EditorMarker, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EditorValidateResponse
 */
export const EditorValidateResponse = new EditorValidateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorScheduleCron$Type extends MessageType<ConnectorScheduleCron> {
    constructor() {
        super("c1.api.app.v1.ConnectorScheduleCron", [
            { no: 1, name: "cron_spec", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorScheduleCron
 */
export const ConnectorScheduleCron = new ConnectorScheduleCron$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateConnectorScheduleRequest$Type extends MessageType<UpdateConnectorScheduleRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateConnectorScheduleRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 100, name: "cron", kind: "message", oneof: "schedule", T: () => ConnectorScheduleCron }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateConnectorScheduleRequest
 */
export const UpdateConnectorScheduleRequest = new UpdateConnectorScheduleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateConnectorScheduleResponse$Type extends MessageType<UpdateConnectorScheduleResponse> {
    constructor() {
        super("c1.api.app.v1.UpdateConnectorScheduleResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateConnectorScheduleResponse
 */
export const UpdateConnectorScheduleResponse = new UpdateConnectorScheduleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorSyncCronSchedule$Type extends MessageType<ConnectorSyncCronSchedule> {
    constructor() {
        super("c1.api.app.v1.ConnectorSyncCronSchedule", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "cron_spec", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorSyncCronSchedule
 */
export const ConnectorSyncCronSchedule = new ConnectorSyncCronSchedule$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.ConnectorService
 */
export const ConnectorService = new ServiceType("c1.api.app.v1.ConnectorService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/connectors/{id}", group: "Connector" }] } }, I: ConnectorServiceGetRequest, O: ConnectorServiceGetResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/connectors", query: { page_size: "page_size", page_token: "page_token" }, group: "Connector" }] } }, I: ConnectorServiceListRequest, O: ConnectorServiceListResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors/create", group: "Connector" }] } }, I: ConnectorServiceCreateRequest, O: ConnectorServiceCreateResponse },
    { name: "CreateDelegated", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors", group: "Connector" }] } }, I: ConnectorServiceCreateDelegatedRequest, O: ConnectorServiceCreateResponse },
    { name: "Upload", options: { "authz.method": { role: "EDITOR" } }, I: ConnectorServiceUploadRequest, O: ConnectorServiceUploadResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{connector.app_id}/connectors/{connector.id}", group: "Connector" }] } }, I: ConnectorServiceUpdateRequest, O: ConnectorServiceUpdateResponse },
    { name: "UpdateAllowIgnoreList", options: { "authz.method": { role: "EDITOR" } }, I: ConnectorServiceUpdateAllowIgnoreListRequest, O: ConnectorServiceUpdateResponse },
    { name: "UpdateConnectorSyncResourceTypesConfig", options: { "authz.method": { role: "EDITOR" } }, I: ConnectorServiceUpdateSyncResourceTypesConfigRequest, O: ConnectorServiceUpdateResponse },
    { name: "UpdateAdvancedConfig", options: { "authz.method": { role: "EDITOR" } }, I: ConnectorServiceUpdateAdvancedConfigRequest, O: ConnectorServiceUpdateResponse },
    { name: "UpdateDelegated", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{connector.app_id}/connectors/{connector.id}/delegated", group: "Connector" }] } }, I: ConnectorServiceUpdateDelegatedRequest, O: ConnectorServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/connectors/{id}", group: "Connector" }] } }, I: ConnectorServiceDeleteRequest, O: ConnectorServiceDeleteResponse },
    { name: "Logs", options: { "authz.method": { role: "VIEWER" } }, I: ConnectorServiceLogsRequest, O: ConnectorServiceLogsResponse },
    { name: "CreateAuthorizeURL", options: { "authz.method": { role: "EDITOR" } }, I: CreateAuthorizeURLRequest, O: CreateAuthorizeURLResponse },
    { name: "GetConnectorConfigFieldActivity", options: { "authz.method": { role: "EDITOR" } }, I: GetConnectorConfigFieldActivityRequest, O: GetConnectorConfigFieldActivityResponse },
    { name: "ForceSync", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/force_sync", group: "Connector" }] } }, I: ForceSyncRequest, O: ForceSyncResponse },
    { name: "ResumeSync", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/resume", group: "Connector" }] } }, I: ResumeSyncRequest, O: ResumeSyncResponse },
    { name: "ConfirmSyncValid", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/confirm_sync_valid/{sync_lifecycle_id}", group: "Connector" }] } }, I: ConfirmSyncValidRequest, O: ConfirmSyncValidResponse },
    { name: "PauseSync", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/pause", group: "Connector" }] } }, I: PauseSyncRequest, O: PauseSyncResponse },
    { name: "GetCredentials", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/credentials/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "ConnectorCredential" }], group: "Connector" }] } }, I: ConnectorServiceGetCredentialsRequest, O: ConnectorServiceGetCredentialsResponse },
    { name: "ListCredentials", options: { "authz.method": { role: "OWNER" } }, I: ConnectorServiceListCredentialsRequest, O: ConnectorServiceListCredentialsResponse },
    { name: "RotateCredential", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/connectors/credentials", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "ConnectorCredential" }], group: "Connector" }] } }, I: ConnectorServiceRotateCredentialRequest, O: ConnectorServiceRotateCredentialResponse },
    { name: "RevokeCredential", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/credentials/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "ConnectorCredential" }], group: "Connector" }] } }, I: ConnectorServiceRevokeCredentialRequest, O: ConnectorServiceRevokeCredentialResponse },
    { name: "GetConnectorSyncLifecycle", options: { "authz.method": { role: "VIEWER" } }, I: GetConnectorSyncLifecycleRequest, O: ConnectorSyncLifecycle },
    { name: "ListCompletedConnectorSyncLifecycle", options: { "authz.method": { role: "VIEWER" } }, I: ListCompletedConnectorSyncLifecycleRequest, O: ListCompletedConnectorSyncLifecycleResponse },
    { name: "GetConnectorExternalSourceConfig", options: { "authz.method": { role: "EDITOR" } }, I: ConnectorExternalSourceConfigGetRequest, O: ConnectorExternalSourceConfig },
    { name: "SetConnectorExternalSourceConfig", options: { "authz.method": { role: "EDITOR" } }, I: ConnectorExternalSourceConfigSetRequest, O: ConnectorExternalSourceConfig },
    { name: "ListConnectorSyncLifecycle", options: { "authz.method": { role: "VIEWER" } }, I: ListConnectorSyncLifecycleRequest, O: ListConnectorSyncLifecycleResponse },
    { name: "GetConnectorSyncDownloadURL", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/syncs/{sync_id}/download_url", group: "Connector" }] } }, I: GetConnectorSyncDownloadURLRequest, O: GetConnectorSyncDownloadURLResponse },
    { name: "ValidateHTTPConnectorConfig", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/connectors/validate_config/http", group: "Connector" }] } }, I: EditorValidateRequest, O: EditorValidateResponse },
    { name: "UpdateConnectorSchedule", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/schedule", stability: "STABILITY_ALPHA", group: "Connector" }] } }, I: UpdateConnectorScheduleRequest, O: UpdateConnectorScheduleResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppConnectorAccountCreationSchemaService
 */
export const AppConnectorAccountCreationSchemaService = new ServiceType("c1.api.app.v1.AppConnectorAccountCreationSchemaService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetConnectorAccountCreationSchemaRequest, O: GetConnectorAccountCreationSchemaResponse }
]);
